import { createContext } from 'react'
import type { VideoContextType } from './types'

export const VideoContext = createContext<VideoContextType | undefined>(
  undefined,
)
